<template>
    <div class="d-flex flex-column align-center">
        <div class="d-flex align-center justify-center">
            <p class="mb-0">Need Help?</p>
            <p class="mb-0 ml-8">
                <v-icon color="black" small>mdi-phone</v-icon>
                <span class="ml-2">Call Support: +30 212 1042659</span>
            </p>
            <p class="mb-0 ml-8">
                <v-icon color="black" small>mdi-email-outline</v-icon>
                <span class="ml-2">Email: info@dn2me.com</span>
            </p>
        </div>
        <p class="mb-0 light">DoctorNext2Me © {{currentYear}}. All Rights Reserved. </p>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    computed: {
        currentYear(){
            return moment().year()
        }
    }
}
</script>

<style scoped lang="scss">
p{
    font-size: 12px;
}
</style>